module.exports = __webpack_public_path__ + "static/full-stack-project-42-1-9076d1fbaefddcf208d9cc5f14bcf9c5.png";